import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { fetchMessagesList, resetInbox } from 'message/actions/inbox.actions';
import { fetchUnreadMessagesCount } from 'message/actions/unread-count.actions';
import { isRetailerDashboardSelector } from 'selectors';
import MessagesWidgetTemplate from './messages-widget.html';

const mapStateToThis = ({ messages, session, config, retailerDashboards }) => {
  const { unreadCount, inbox, isLoading } = messages;
  const { locale } = session;
  const { defaultPageNo } = config;
  const isRetailerDashboard = isRetailerDashboardSelector({ retailerDashboards });

  return {
    unreadCount,
    isLoading,
    messages: inbox,
    locale,
    isRetailerDashboard,
    defaultPageNo,
  };
};

const mapDispatchToThis = {
  fetchMessagesList,
  fetchUnreadMessagesCount,
  resetInbox,
};

const MESSAGE_COUNT = 3;

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux')
class MessagesWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.loadDataAsync(() =>
      this.isRetailerDashboard
        ? Promise.resolve()
        : Promise.all([
            this.fetchMessagesList({
              setPagination: false, // param to omit pagination calculation to avoid UI collision in widgets [RWZ-7697]
              pageNumber: this.defaultPageNo,
              pageSize: MESSAGE_COUNT,
              sortProperty: 'creationDate',
              ascending: false,
            }),
            this.fetchUnreadMessagesCount(),
          ])
    );
  }

  $onDestroy() {
    this.resetInbox();
    this.unsubscribe();
  }
}

export default class MessagesWidgetComponent {
  constructor() {
    this.template = MessagesWidgetTemplate;
    this.controller = MessagesWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/messages/messages-widget-component.js